import React, { useContext } from 'react';

import { LessonDisplayMode } from './LessonComponent';
import { LessonType } from '../../dashboard/models/LessonVm';

interface LessonContextModel {
  mode: LessonDisplayMode;
  lessonType?: LessonType; //* not required in 'edit' mode
  finalized: boolean;
  quizLocked: boolean;
  assessmentSubmitted?: boolean; //* only for 'assessment' lesson type in the 'learn' display mode.
  assessmentRevised?: boolean; //* only for 'assessment'. At least one answer has been updated after further work is requested.
  /** Used in leaner's portfolio to disable old version attempts. */
  portfolioLocked?: boolean;
}

const LessonContext = React.createContext<LessonContextModel>({
  mode: null,
  lessonType: null,
  finalized: false,
  quizLocked: false,
  assessmentSubmitted: false,
  assessmentRevised: false,
  portfolioLocked: false
});

export const useLessonContext = () => useContext(LessonContext);

export const LessonContextProvider = LessonContext.Provider;
export const LessonContextConsumer = LessonContext.Consumer;
export default LessonContext;
